import { useNavigate, Link } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../config/fbConfig';
import React, { useEffect, useState } from 'react';
import { useUserAuth } from "../context/UserAuthContext";
import Logo from '../images/school_logo.png';
import '../styles/Archives.css';

const Archives = () => {
  const { user, userData } = useUserAuth();
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSections = async () => {
      try {
        const snap = await getDocs(collection(db, 'sections'));
        const sortedSections = snap.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .sort((a, b) => a.name.localeCompare(b.name));
        setSections(sortedSections);
      } catch (error) {
        console.error('Error fetching sections:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchSections();
  }, []);

  const allowedRoles = ['Admin', 'Cashier'];

  return (
    <>  
      {allowedRoles.includes(userData.status) ? (
        <>    
      <div className="top-elements row align-center space-between">
        <button onClick={() => navigate(-1)} className="back-link back-link1">
          <i className="fa-solid fa-arrow-left size3"></i>
        </button>
        <div className="column align-center justify-center">
          <img src={Logo} className="middle-logo" alt="logo" />
        </div>
        <Link to="#" className="home-link" onClick={() => window.location.reload()}>
          <i className="fa-solid fa-rotate-right size4"></i>
        </Link>
      </div>

      <div className="login-page-items column align-center">
        <div className='breadcrumb'>
          <button className="back-link back-link1 back-link2">
            Section
          </button>
        </div>
        <h2 className="manage-page-heading manage-page-heading-select caps size4">Select Section</h2>
        <div className="scroll-fixed scroll-fixed1">
          <div className="class-list class-list-d scrollable class-items">
            {loading ? (
              <p className="loading-text male-female-stat">Loading sections...</p>
            ) : sections.length === 0 ? (
              <p className="empty-text male-female-stat">No sections available.</p>
            ) : (
              sections.map(section => (
                <div key={section.id}>
                  <button className="class-item class-item1 class-item1-d" onClick={() => navigate(`/archives/${section.id}`)}>
                    {section.name}
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
      </>
      ) : (
        <p className="male-female-stat align-center justify-center">You don't have permission to view this page.</p>
      )}
    </>
  );
};

export default Archives;
